<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style">
            <li class="breadcrumb-item">
              <h4 class="page-title">Dashboard</h4>
            </li>
            <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item active">Dashboard</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h3>{{ headerText }}</h3>
      </div>
      <div class="col-md-6 d-flex justify-content-end">
        <button class="button" (click)="toggleReport()">
          {{ buttonText }}
        </button>
      </div>
    </div>
    <!-- Widgets -->
    <div class="row">
      <div class="col">
        <div class="counter-box text-center" style="background-color: pink">
          <div class="text font-20 m-b-5" style="color: grey; font-weight: bold">
            Total Orders
          </div>
          <h2 class="m-b-10">{{ no_of_orders_tc }}</h2>
        </div>
      </div>
      <div class="col">
        <div class="counter-box text-center" style="background-color: #ffffd0">
          <div class="text font-20 m-b-5" style="color: grey; font-weight: bold">
            Agent Orders
          </div>
          <h2 class="m-b-10">{{ no_of_agents_tc }}</h2>
        </div>
      </div>
      <div class="col">
        <div class="counter-box text-center" style="background-color: #e8ffe8">
          <div class="text font-20 m-b-5" style="color: grey; font-weight: bold">
            Customer Orders
          </div>
          <h2 class="m-b-10">{{ no_of_cardcust_tc }}</h2>
        </div>
      </div>

      <div class="col">
        <div class="counter-box text-center" style="background-color: #e6e6fa">
          <div class="text font-20 m-b-5" style="color: grey; font-weight: bold">
            Employees
          </div>
          <h2 class="m-b-10">{{ no_of_employee_tc }}</h2>
        </div>
      </div>
      <div class="col">
        <div class="counter-box text-center" style="background-color: #e3bc9a">
          <div class="text font-20 m-b-5" style="color: grey; font-weight: bold">
            Ex Employees
          </div>
          <h2 class="m-b-10">{{ no_of_ex_employee_tc }}</h2>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- First column with nested columns for Milk and Curd -->
      <div class="col-sm-6 col-md-6 col-lg-6 custom-col">
        <div class="counter-box text-center white">
          <h4 class="text-center">Milk</h4>
          <table class="table table-bordered table-striped-alt right-align-table">
            <thead>
              <tr>
                <th style="text-align: left">Product</th>
                <th style="text-align: right">Litres</th>
              </tr>
            </thead>
            <tbody>
              <!-- Iterate through productLitres data -->
              <tr *ngFor="let item of productLitres">
                <td>{{ item.product }}</td>
                <td style="text-align: right">
                  {{ formatNumberWithCommas(item.litres) }} L
                </td>
              </tr>
            </tbody>
            <!-- Total Order row with bold border and background color -->
            <tfoot>
              <tr class="bold-border" style="background-color: #d1e7dd; font-weight: bold">
                <td>Total Order</td>
                <td style="text-align: right">
                  {{ formatNumberWithCommas(totalMilkLiters) }} L
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Nested table for Curd -->
        <div class="counter-box text-center white">
          <h4 class="text-center">Curd</h4>
          <table class="table table-bordered table-striped-alt right-align-table">
            <thead>
              <tr>
                <th style="text-align: left">Product</th>
                <th style="text-align: right">Litres</th>
              </tr>
            </thead>
            <tbody>
              <!-- Iterate through productcurdtLitres data -->
              <tr *ngFor="let item of productCurdLitres">
                <td>{{ item.product }}</td>
                <td style="text-align: right">
                  {{ formatNumberWithCommas(item.litres) }} L
                </td>
              </tr>
            </tbody>
            <!-- Total Order row with bold border and background color -->
            <tfoot>
              <tr class="bold-border" style="background-color: #d1e7dd; font-weight: bold">
                <td>Total Order</td>
                <td style="text-align: right">
                  {{ formatNumberWithCommas(totalCurdLiters) }} L
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="counter-box text-center white">
          <h4 class="text-center">Zone Wise Comparison</h4>
          <table class="table table-bordered table-striped-alt right-align-table">
            <thead>
              <tr>
                <th style="text-align: left">Zone Name</th>
                <th style="text-align: right">Yesterday's Total Cost</th>
                <th style="text-align: right">Today's Total Cost</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of combinedZoneData">
                <td>{{ item.zone_name }}</td>
                <td style="text-align: right">
                  {{ item.yesterday_total_cost | currency:'INR' }}
                </td>
                <td style="text-align: right">
                  {{ item.today_total_cost | currency:'INR' }}
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr class="bold-border" style="background-color: #d1e7dd; font-weight: bold">
                <td>Total</td>
                <td style="text-align: right">
                  {{ calculateTotalYesterdayCostZone() | currency:'INR' }}
                </td>
                <td style="text-align: right">
                  {{calculateTotalTodayCostZone() | currency:'INR' }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <!-- Second column -->
      <div class="col-sm-6 col-md-6 col-lg-6 custom-col">
        <div class="counter-box text-center white">
          <h4 class="text-center">ByProduct</h4>
          <table class="table table-bordered table-striped-alt right-align-table">
            <thead>
              <tr>
                <th style="text-align: left">Product</th>
                <th style="text-align: right">Cost</th>
              </tr>
            </thead>
            <tbody>
              <!-- Iterate through byProductData array -->
              <tr *ngFor="let item of byProductData">
                <td>{{ item.product }}</td>
                <td style="text-align: right">
                  {{ item.litres | currency:'INR' }}
                </td>
              </tr>
            </tbody>
            <!-- Total Order row with bold border and background color -->
            <tfoot>
              <tr class="bold-border" style="background-color: #d1e7dd; font-weight: bold">
                <td style="text-align: left">Total Cost</td>
                <td style="text-align: right">
                  {{ totalByProductLiters | currency:'INR' }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="counter-box text-center white">
          <h4 class="text-center">Union Wise Comparison</h4>
          <table class="table table-bordered table-striped-alt right-align-table">
            <thead>
              <tr>
                <th style="text-align: left">Union Name</th>
                <th style="text-align: right">Yesterday's Total Cost</th>
                <th style="text-align: right">Today's Total Cost</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of combinedUnionData">
                <td>{{ item.union_name }}</td>
                <td style="text-align: right">
                  {{ item.yesterday_total_cost | currency:'INR' }}
                </td>
                <td style="text-align: right">
                  {{ item.today_total_cost | currency:'INR' }}
                </td>
              </tr>
            </tbody>

            <!-- Extra row for totals -->
            <tfoot>
              <tr class="bold-border" style="background-color: #d1e7dd; font-weight: bold">
                <td>Total</td>
                <td style="text-align: right">
                  {{ calculateTotalYesterdayCostUnion() | currency:'INR' }}
                </td>
                <td style="text-align: right">
                  {{ calculateTotalTodayCostUnion() | currency:'INR' }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="col-md-6">
        <div class="counter-box text-center white">
          <h4 class="text-center">Online Payment Status</h4>
          <table class="table table-bordered table-striped-alt right-align-table">
            <thead>
              <tr>
                <th style="text-align: left">Payment status</th>
                <th style="text-align: right">Count</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of paymentStatus">
                <td>{{ item.status_label }}</td>
                <td style="text-align: right">{{ item.count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-md-6" *ngIf="walletData">
        <div class="counter-box text-center white">
          <h4 class="text-center">Wallet</h4>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

          <div class="table-container">
            <table style="border: none; border-collapse: collapse">
              <tbody>
                <tr>
                  <td>
                    <i class="fas fa-arrow-circle-down green-icon"></i> Credited
                    Amount
                  </td>
                  <td style="text-align: right">
                    {{ walletData.total_amount_credited | currency:'INR' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fas fa-arrow-circle-up red-icon"></i> Debited
                    Amount
                  </td>
                  <td style="text-align: right">
                    {{ walletData.total_amount_debited | currency:'INR' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-toggle/2.2.2/js/bootstrap-toggle.min.js"></script>
<script>
  const toggle = document.getElementById("toggle");
  const toggleText = document.getElementById("toggleText");

  toggle.addEventListener("change", function () {
    if (this.checked) {
      toggleText.textContent = "Yesterday";
    } else {
      toggleText.textContent = "Today";
    }
  });
</script>